import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {

    // 🔹 Load cart from localStorage (FIRST TIME)
    const [cartItems, setCartItems] = useState(() => {
        const storedCart = localStorage.getItem("balaji_cart");
        return storedCart ? JSON.parse(storedCart) : [];
    });

    // 🔹 Save cart to localStorage (EVERY CHANGE)
    useEffect(() => {
        localStorage.setItem("balaji_cart", JSON.stringify(cartItems));
    }, [cartItems]);

    // ➕ Add to Cart
    const addToCart = (product, variant) => {
        setCartItems(prev => {
            const index = prev.findIndex(
                item =>
                    item.product.id === product.id &&
                    item.variant.weight === variant.weight
            );

            if (index !== -1) {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    qty: updated[index].qty + 1,
                };
                return updated;
            }

            return [...prev, { product, variant, qty: 1 }];
        });
    };

    // ➕ Increase Qty
    const increaseQty = (index) => {
        setCartItems(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, qty: item.qty + 1 } : item
            )
        );
    };

    // ➖ Decrease Qty (0 होने पर remove)
    const decreaseQty = (index) => {
        setCartItems(prev =>
            prev
                .map((item, i) =>
                    i === index ? { ...item, qty: item.qty - 1 } : item
                )
                .filter(item => item.qty > 0)
        );
    };

    // ❌ Remove item
    const removeFromCart = (index) => {
        setCartItems(prev => prev.filter((_, i) => i !== index));
    };

    // 🧹 Clear cart (localStorage भी clear)
    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem("balaji_cart");
    };

    return (
        <CartContext.Provider
            value={{
                cartItems,
                addToCart,
                increaseQty,
                decreaseQty,
                removeFromCart,
                clearCart,
            }}
        >
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
